import React, { FC, useEffect, useState } from 'react';
import { Button, Spin } from 'antd';
import { Connection, Device } from 'twilio-client';
import { AudioMutedOutlined, AudioOutlined, Phone } from 'common/const/svg';
import { useCallTimer } from 'common/hooks';
import { getFormattedTime } from 'common/helpers';

interface IComponentProps {
  token: string | null;
  phone?: string;
  onCall: boolean;
  setOnCall: (onCall: boolean) => void;
  setDuration: (duration: number) => void;
  onEndCallClick: () => void;
}

export const VoiceCallActive: FC<IComponentProps> = ({ token, phone, onCall, setOnCall, setDuration, onEndCallClick }) => {
  const [mute, setMute] = useState<boolean>(false);
  const [device, setDevice] = useState<Device | null>(null);
  const [connection, setConnection] = useState<Connection | null>(null);
  const { milliseconds: duration } = useCallTimer(onCall);

  const toggleMute = () => {
    setMute((prev) => {
      if (connection) {
        prev ? connection.mute(false) : connection.mute(true);
      }

      return !prev;
    });
  };

  const handleEndCallClick = () => {
    device?.disconnectAll();
    onEndCallClick();
  };

  useEffect(() => {
    const device = new Device();

    if (token) {
      device.setup(token);

      device.on('ready', () => {
        setDevice(device);
        const connection = device.connect({ number: phone as string });
        setConnection(connection);
      });

      device.on('connect', () => {
        setOnCall(true);
      });

      device.on('disconnect', () => {
        handleEndCallClick();
      });
    }

    return () => {
      device.destroy();
      setDevice(null);
      setConnection(null);
    };
  }, [token]);

  useEffect(() => {
    if (onCall) {
      setDuration(duration);
    }
  }, [onCall, duration]);

  return (
    <div className="call">
      <div className="d-flex align-center justify-center" style={{ height: 160 }}>
        {!onCall ? <Spin /> : <span className="ff-medium fs-lg">{getFormattedTime(duration, 'mm:ss')}</span>}
      </div>

      <div className="d-flex align-center justify-center" style={{ gap: 16 }}>
        <Button className="default icon" icon={mute ? <AudioMutedOutlined /> : <AudioOutlined />} onClick={toggleMute} />

        <Button className="red call__end-call" icon={<Phone />} onClick={handleEndCallClick}>
          End call
        </Button>
      </div>
    </div>
  );
};
